import React from "react";

import { Badge } from "~/components/ui/badge";
import {
  QUOTATION_STATUS_COLORS,
  QUOTATION_STATUS_LABELS,
  QuotationStatus,
} from "~/types/quotation";

interface QuotationStatusBadgeProps {
  status: QuotationStatus;
  className?: string;
}

const QuotationStatusBadge: React.FC<QuotationStatusBadgeProps> = ({
  status,
  className = "",
}) => {
  const label = QUOTATION_STATUS_LABELS[status] || status;
  const colorClass = QUOTATION_STATUS_COLORS[status] || "bg-gray-100 text-gray-800";

  return (
    <Badge variant="outline" className={`${colorClass} ${className}`}>
      {label}
    </Badge>
  );
};

export default QuotationStatusBadge;
